import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import NewsPreview from "@/pages/home/components/NewsPreview";
import SectionTitle from "@/components/base/SectionTitle";
import WorkGrid from "@/components/base/WorkGrid";
import { getWorksByCategory, getLatest, getFeatured } from "@/utils/film";
import { siteStats } from "@/mocks/home";

export default function Home() {
  const movies = getWorksByCategory("movie");
  const tvList = getWorksByCategory("tv");
  const featuredMovies = getLatest(movies, 6);
  const featuredTv = getFeatured(tvList, 6);

  return (
    <div className="animate-fadeIn">
      <HeroCarousel />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-4 px-4 py-8 md:grid-cols-4 md:px-6">
          {siteStats.map((stat) => (
            <div key={stat.label} className="text-center md:text-left">
              <p className="font-label text-2xl font-bold text-foreground-950 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          icon="ri-movie-2-line"
          title="电影频道精选"
          description="近期热门与新上线电影，查看剧情、主创与评分"
          moreHref="/movies"
          moreLabel="进入电影频道"
        />
        <div className="mt-8">
          <WorkGrid works={featuredMovies} emptyTitle="当前暂无推荐内容" />
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <SectionTitle
            icon="ri-tv-line"
            title="电视剧频道精选"
            description="高分剧集与热播新剧，一网打尽"
            moreHref="/tvseries"
            moreLabel="进入电视剧频道"
          />
          <div className="mt-8">
            <WorkGrid works={featuredTv} emptyTitle="当前暂无推荐内容" />
          </div>
        </div>
      </section>

      <NewsPreview />

      <section className="mx-auto max-w-7xl px-4 pb-16 md:px-6">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-primary-500">
          <div className="grid grid-cols-1 items-center gap-8 p-8 md:grid-cols-2 md:p-12">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-bookmark-3-line"></i>
                关于白虎
              </span>
              <h2 className="mt-4 text-2xl font-black leading-tight text-background-50 md:text-3xl">
                找一部好片，从了解它开始
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
                白虎致力于为影视爱好者打造一个权威、全面的内容展示平台。我们用清晰的分类、详尽的资料与及时的资讯，
                帮你在观影前做出更好的选择。收藏喜欢的作品，随时回来查看。
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  了解更多
                </Link>
                <Link
                  to="/favorites"
                  className="whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  我的收藏
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: "ri-search-line", label: "快速检索", desc: "按名称模糊查找" },
                { icon: "ri-filter-3-line", label: "多维筛选", desc: "类型 / 地区 / 年份" },
                { icon: "ri-bookmark-line", label: "本地收藏", desc: "刷新后仍然保留" },
                { icon: "ri-newspaper-line", label: "影视资讯", desc: "动态与预告速览" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="rounded-md border border-background-50/15 bg-background-50/5 p-4"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
                    <i className={item.icon}></i>
                  </span>
                  <p className="mt-3 text-sm font-semibold text-background-50">{item.label}</p>
                  <p className="mt-1 text-xs text-background-200">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}